import React, {Fragment} from 'react';
import {Button, Card, Checkbox, Col, Form, Input, Modal, Row, Select} from 'antd';
import LoaderCsvFormMappingControl from './mapping-control';
import {
  GUTTER_MD,
  MARGIN_MD,
  MODAL_WIDTH_SM,
  SPAN_FULL,
  SPAN_HALF,
  SPAN_ONE_THIRD
} from '../../../../styles/constants';
import {
  changeLoaderCsvForm,
  convertLoaderCsvFormPxToCsv, convertLoaderCsvFormXlsToCsv,
  onHideLoaderCsvFormIgnoreConcurrentUploadConfirm,
  submitLoaderCsvForm,
  uploadLoaderCsvFormFile
} from './actions';
import {translate} from 'react-i18next';
import {compose} from 'redux';
import FileInput from '../../../../components/file-input';
import {connect} from 'react-redux';
import LoaderCsvFormRowList from './row-list';
import {showLoaderCsvFormRowList} from './row-list/actions';
import {userMustNotInsertTid} from './utils';
import EmbargoInput from '../../../../components/embargo-input';
import Call from "../../../../hocs/call";
import {isIDValidWithHelp} from "../../../../utils/artefactValidators";
import "./style.css";

const mapStateToProps = state => ({
  format: state.scenes.dataManager.loader.shared.format,
  mappingId: state.scenes.dataManager.loader.components.csvForm.shared.mappingId,
  mapping: state.scenes.dataManager.loader.components.csvForm.shared.mapping,
  mappingCube: state.scenes.dataManager.loader.components.csvForm.shared.mappingCube,
  tid: state.scenes.dataManager.loader.components.csvForm.shared.tid,
  importType: state.scenes.dataManager.loader.components.csvForm.local.importType,
  file: state.scenes.dataManager.loader.components.csvForm.local.file,
  separator: state.scenes.dataManager.loader.components.csvForm.shared.separator,
  delimiter: state.scenes.dataManager.loader.components.csvForm.shared.delimiter,
  hasHeader: state.scenes.dataManager.loader.components.csvForm.shared.hasHeader,
  hasDotStatFormat: state.scenes.dataManager.loader.components.csvForm.shared.hasDotStatFormat,
  fileServerPath: state.scenes.dataManager.loader.components.csvForm.shared.fileServerPath,
  csvServerPath: state.scenes.dataManager.loader.components.csvForm.shared.csvServerPath,
  embargo: state.scenes.dataManager.loader.components.csvForm.local.embargo,
  refreshProdDf: state.scenes.dataManager.loader.components.csvForm.local.refreshProdDf,
  checkFiltAttributes: state.scenes.dataManager.loader.components.csvForm.local.checkFiltAttributes,
  isIgnoreConcurrentUploadConfirmVisible: state.scenes.dataManager.loader.components.csvForm.local.isIgnoreConcurrentUploadConfirmVisible
});

const mapDispatchToProps = dispatch => ({
  onChange: fields => dispatch(changeLoaderCsvForm(fields)),
  onFileUpload: (file, mappingCubeId, format) => dispatch(uploadLoaderCsvFormFile(file, mappingCubeId, format)),
  onRowListShow: () => dispatch(showLoaderCsvFormRowList()),
  onSubmit: (separator, delimiter, hasHeader, importType, cubeId, mappingId, filePath, tid, cubeCode, idMappingSpecialTimePeriod, embargo, refreshProdDf, checkFiltAttributes, ignoreConcurrentUpload) =>
    dispatch(submitLoaderCsvForm(separator, delimiter, hasHeader, importType, cubeId, mappingId, filePath, tid, cubeCode, idMappingSpecialTimePeriod, embargo, refreshProdDf, checkFiltAttributes, ignoreConcurrentUpload)),
  onHideIgnoreConcurrentUploadConfirm: () => dispatch(onHideLoaderCsvFormIgnoreConcurrentUploadConfirm()),
  onConvertPxToCsv: ({
                       fileServerPath,
                       cubeId
                     }) => dispatch(convertLoaderCsvFormPxToCsv(fileServerPath, cubeId)),
  onConvertXlsToCsv: ({
                        fileServerPath,
                        xmlFileServerPath,
                        cubeId
                      }) => dispatch(convertLoaderCsvFormXlsToCsv(fileServerPath, xmlFileServerPath, cubeId))
});

const mapPropsToFields = ({
                            mapping,
                            tid,
                            importType,
                            file,
                            separator,
                            delimiter,
                            hasHeader,
                            hasDotStatFormat,
                            embargo,
                            refreshProdDf,
                            checkFiltAttributes
                          }) => ({
  mappingId: Form.createFormField({value: mapping !== null ? `[${mapping.Name}] ${mapping.Description || ''}` : null}),
  tid: Form.createFormField({value: tid}),
  importType: Form.createFormField({value: importType}),
  file: Form.createFormField({value: file}),
  separator: Form.createFormField({value: separator}),
  delimiter: Form.createFormField({value: delimiter}),
  hasHeader: Form.createFormField({value: hasHeader}),
  hasDotStatFormat: Form.createFormField({value: hasDotStatFormat}),
  embargo: Form.createFormField({value: embargo}),
  refreshProdDf: Form.createFormField({value: refreshProdDf}),
  checkFiltAttributes: Form.createFormField({value: checkFiltAttributes}),
});

const onFieldsChange = (props, fields) => props.onChange(fields);

const LoaderCsvForm = ({
                         t,
                         format,
                         form,
                         mappingId,
                         mapping,
                         mappingCube,
                         tid,
                         importType,
                         file,
                         separator,
                         hasHeader,
                         hasDotStatFormat,
                         delimiter,
                         fileServerPath,
                         csvServerPath,
                         onFileUpload,
                         onRowListShow,
                         onSubmit,
                         embargo,
                         refreshProdDf,
                         checkFiltAttributes,
                         isIgnoreConcurrentUploadConfirmVisible,
                         onHideIgnoreConcurrentUploadConfirm,
                         onConvertPxToCsv,
                         onConvertXlsToCsv
                       }) =>
  <Call cb={onConvertPxToCsv}
        cbParam={{fileServerPath, cubeId: mappingCube ? mappingCube.IDCube : null}}
        disabled={!mappingCube || format !== 'px' || fileServerPath === null}>
    <Call cb={onConvertXlsToCsv}
          cbParam={{
            fileServerPath,
            xmlFileServerPath: mapping ? mapping.XMLFilePath : null,
            cubeId: mappingCube ? mappingCube.IDCube : null
          }}
          disabled={!mappingCube || format !== 'xls' || fileServerPath === null || !mapping || !mapping.XMLFilePath}>
      <Row type="flex" justify="center">
        <Col style={{width: MODAL_WIDTH_SM}}>
          <Card type="inner">
            <Form className="advanced-form">
              <Row gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
                <Col span={SPAN_FULL}>
                  <Form.Item className="form-item-required"
                             label={t('scenes.dataManager.loader.csvForm.fields.mapping.label')}>
                    <LoaderCsvFormMappingControl form={form}/>
                  </Form.Item>
                </Col>
              </Row>
              {!userMustNotInsertTid(mapping, mappingCube) && (
                <Row gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
                  <Col span={SPAN_FULL}>
                    <Form.Item
                      className="form-item-required"
                      label={t('scenes.dataManager.loader.csvForm.fields.tid.label')}
                      validateStatus={tid && isIDValidWithHelp(t, tid).help ? "warning" : null}
                      help={tid && isIDValidWithHelp(t, tid).help}
                    >
                      {form.getFieldDecorator('tid', {
                        getValueFromEvent: e => e.target.value.toUpperCase()
                      })(<Input style={{textTransform: "uppercase"}}/>)}
                    </Form.Item>
                  </Col>
                </Row>
              )}
              <Row gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
                <Col span={SPAN_FULL}>
                  <Form.Item
                    className="form-item-required"
                    label={t('scenes.dataManager.loader.csvForm.fields.importType.label')}
                  >
                    {form.getFieldDecorator('importType')(
                      <Select
                        showSearch
                        filterOption={(inputValue, {props}) =>
                          props.title.toLowerCase().includes(inputValue.toLowerCase())
                        }
                        disabled={
                          mappingId === null ||
                          (
                            !userMustNotInsertTid(mapping, mappingCube)
                            &&
                            (tid === null || tid.length === 0)
                          )
                        }
                      >
                        <Select.Option
                          value="SeriesAndData"
                          title={t('scenes.dataManager.loader.csvForm.fields.importType.option.SeriesAndData')}
                        >
                          {t('scenes.dataManager.loader.csvForm.fields.importType.option.SeriesAndData')}
                        </Select.Option>
                        <Select.Option
                          value="Series"
                          title={t('scenes.dataManager.loader.csvForm.fields.importType.option.Series')}
                        >
                          {t('scenes.dataManager.loader.csvForm.fields.importType.option.Series')}
                        </Select.Option>
                        <Select.Option
                          value="Data"
                          title={t('scenes.dataManager.loader.csvForm.fields.importType.option.Data')}
                        >
                          {t('scenes.dataManager.loader.csvForm.fields.importType.option.Data')}
                        </Select.Option>
                      </Select>
                    )}
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
                <Col span={SPAN_FULL}>
                  <Form.Item className="form-item-required" label={t('data.csv.file.label')}>
                    {form.getFieldDecorator('file')(
                      <FileInput
                        disabled={
                          mappingId === null ||
                          (
                            !userMustNotInsertTid(mapping, mappingCube)
                            &&
                            (tid === null || tid.length === 0)
                          )
                        }
                        accept={format === 'xls' ? ".xls,.xlsx" : ("." + format)}
                        isZipAllowed
                      />
                    )}
                  </Form.Item>
                </Col>
              </Row>
              {format === 'csv' && (
                <Fragment>
                  <Row gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
                    <Col span={SPAN_HALF}>
                      <Form.Item className="form-item-required"
                                 label={t('data.csv.separator.label')}>
                        {form.getFieldDecorator('separator')(
                          <Input
                            disabled={
                              mappingId === null ||
                              (
                                !userMustNotInsertTid(mapping, mappingCube)
                                &&
                                (tid === null || tid.length === 0)
                              )
                            }
                            maxLength={1}
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={SPAN_HALF}>
                      <Form.Item label={t('data.csv.delimiter.label')}>
                        {form.getFieldDecorator('delimiter')(
                          <Input
                            disabled={
                              mappingId === null ||
                              (
                                !userMustNotInsertTid(mapping, mappingCube)
                                &&
                                (tid === null || tid.length === 0)
                              )
                            }
                            maxLength={1}
                          />
                        )}
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
                    <Col span={SPAN_HALF}>
                      <Form.Item label={t('data.csv.hasHeader.label')}>
                        {form.getFieldDecorator('hasHeader', {valuePropName: 'checked'})(
                          <Checkbox
                            disabled={
                              mappingId === null ||
                              (
                                !userMustNotInsertTid(mapping, mappingCube)
                                &&
                                (tid === null || tid.length === 0)
                              )
                            }
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={SPAN_HALF}>
                      <Form.Item label={t('data.csv.hasDotStatFormat.label')}>
                        {form.getFieldDecorator('hasDotStatFormat', {valuePropName: 'checked'})(
                          <Checkbox
                            disabled={
                              mappingId === null ||
                              (
                                !userMustNotInsertTid(mapping, mappingCube)
                                &&
                                (tid === null || tid.length === 0)
                              )
                            }
                          />)}
                      </Form.Item>
                    </Col>
                  </Row>
                </Fragment>
              )}
              <Row type="flex" justify="center" gutter={GUTTER_MD}
                   style={{marginBottom: MARGIN_MD}}>
                <Col>
                  <Form.Item>
                    <Button
                      onClick={() => onFileUpload(file, mappingCube.IDCube, format)}
                      disabled={
                        (
                          !userMustNotInsertTid(mapping, mappingCube)
                          &&
                          (tid === null || tid.length === 0)
                        ) ||
                        mappingCube === null ||
                        file === null ||
                        (format === 'csv' && (
                          separator === null ||
                          separator.length === 0 ||
                          hasHeader === null
                        ))
                      }
                      type="primary"
                      icon="upload"
                    >
                      {t('data.csv.uploadButton.label')}
                    </Button>
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item>
                    <Button onClick={onRowListShow} disabled={csvServerPath === null} icon="table">
                      {t('data.csv.tableShowButton.label')}
                    </Button>
                    <LoaderCsvFormRowList/>
                  </Form.Item>
                </Col>
              </Row>
              <Row type="flex" style={{marginBottom: MARGIN_MD}}>
                <Col span={SPAN_FULL}>
                  <Form.Item>
                    {form.getFieldDecorator('embargo')(
                      <EmbargoInput disabled={csvServerPath === null}/>
                    )}
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={SPAN_ONE_THIRD}>
                  <Form.Item>
                    {(() => {
                      const submit = ignoreConcurrentUpload => onSubmit(
                        format === 'csv' ? separator : ';',
                        format === 'csv' ? (!!delimiter ? delimiter : null) : '"',
                        format === 'csv' ? hasHeader : true,
                        importType,
                        mappingCube.IDCube,
                        mappingId,
                        csvServerPath,
                        tid,
                        mappingCube.Code,
                        hasDotStatFormat ? mappingId : null,
                        embargo ? embargo.enabled : false,
                        refreshProdDf,
                        checkFiltAttributes,
                        ignoreConcurrentUpload
                      );
                      return (
                        <Call
                          cb={() => Modal.confirm({
                            title: t('scenes.dataManager.loader.confirms.ignoreConcurrentUpload.title'),
                            content: t('scenes.dataManager.loader.confirms.ignoreConcurrentUpload.content'),
                            onOk() {
                              submit(true);
                              onHideIgnoreConcurrentUploadConfirm();
                            },
                            onCancel() {
                              onHideIgnoreConcurrentUploadConfirm();
                            },
                            cancelText: t('commons.buttons.cancel.title')
                          })}
                          disabled={!isIgnoreConcurrentUploadConfirmVisible}
                        >
                          <Button
                            onClick={() => Modal.confirm({
                              title: t('scenes.dataManager.loader.confirms.submit.title'),
                              onOk() {
                                submit()
                              },
                              cancelText: t('commons.buttons.cancel.title')
                            })}
                            disabled={
                              mappingId === null || mappingCube === null || importType === null ||
                              (
                                !userMustNotInsertTid(mapping, mappingCube)
                                &&
                                (tid === null || tid.length === 0)
                              )
                              || (format === 'csv' && (separator === null || separator.length === 0 || hasHeader === null))
                              || csvServerPath === null
                            }
                            type="primary"
                            icon="check"
                          >
                            {t('scenes.dataManager.loader.csvForm.submitButton.label')}
                          </Button>
                        </Call>
                      );
                    })()}
                  </Form.Item>
                </Col>
                <Col span={SPAN_ONE_THIRD}>
                  <Form.Item label={t('scenes.dataManager.loader.csvForm.refreshProdDf.label')}>
                    {form.getFieldDecorator('refreshProdDf', {valuePropName: 'checked'})(
                      <Checkbox disabled={fileServerPath === null}/>)}
                  </Form.Item>
                </Col>
                <Col span={SPAN_ONE_THIRD}>
                  <Form.Item
                    label={t('scenes.dataManager.loader.csvForm.checkFiltAttributes.label')}>
                    {form.getFieldDecorator('checkFiltAttributes', {valuePropName: 'checked'})(
                      <Checkbox disabled={fileServerPath === null}/>)}
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Card>
        </Col>
      </Row>
    </Call>
  </Call>;

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps),
  Form.create({
    mapPropsToFields,
    onFieldsChange
  })
)(LoaderCsvForm);



// WEBPACK FOOTER //
// ./src/scenes/data-manager/loader/csv-form/index.jsx